import graphql__24c9a6f4f1f5a94ec078 from "./__generated__/ParticipativeModule_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";

import { isAuthorized } from "../Utils/authorizations";
import ParticipativeModuleVisualization from "./ParticipativeModuleVisualization";
import ParticipativeModuleLayout from "./ParticipativeModuleLayout";
import Event from "../Events/Event";
import ModalOutlet from "../Routing/ModalOutlet";

const ParticipativeModule = props => {
  const participativeModule = useFragment(
    ParticipativeModule_participativeModule,
    props.participativeModule
  );

  const { __typename: type } = participativeModule;

  if (type === "Event") {
    return <Event participativeModule={participativeModule} />;
  }

  const { visualizationDisplayAuthorized } = participativeModule.authorizations;

  return (
    <ParticipativeModuleLayout participativeModule={participativeModule}>
      {isAuthorized(visualizationDisplayAuthorized) && (
        <div className="contributions-list-wrapper">
          <ParticipativeModuleVisualization participativeModule={participativeModule} />
        </div>
      )}

      {!isAuthorized(visualizationDisplayAuthorized) && <ModalOutlet />}
    </ParticipativeModuleLayout>
  );
};

const ParticipativeModule_participativeModule = graphql__24c9a6f4f1f5a94ec078;

export default ParticipativeModule;
